<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 181 164"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>entrepreneurs</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="81.8181818"
        cy="81.8181818"
        r="81.8181818" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-1196.000000, -635.000000)">
        <g
          id="entrepreneurs"
          transform="translate(1197.000000, 635.000000)">
          <g id="New_Symbol_58-2">
            <path
              id="Path"
              d="M171.06367,81.8636364 C171.078942,48.4388367 150.761247,18.3656261 119.745726,5.90549507 C88.7302037,-6.55463598 53.2541424,1.10407148 30.1412032,25.2496612 C7.02826396,49.395251 0.926508164,85.1719934 14.7295455,115.613636 L163.781818,115.613636 C168.591219,105.012673 171.074186,93.5045405 171.06367,81.8636364 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="9.49318182"
              y1="115.613636"
              x2="169.038636"
              y2="115.613636"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="0.288636364"
              y1="115.613636"
              x2="5.40227273"
              y2="115.613636"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="173.129545"
              y1="115.613636"
              x2="178.243182"
              y2="115.613636"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <path
            id="Path"
            d="M70.8363739,43 C70.8438966,36.6788211 66.7053949,31.1006566 60.6536033,29.2749574 C54.6018117,27.4492582 48.068888,29.8080763 44.579381,35.0788163 C41.089874,40.3495563 41.4695763,47.2848964 45.5136364,52.1431818 C47.3387769,54.3457858 48.3371915,57.1167481 48.3363636,59.9772727 L48.3363636,65.5 C48.3363636,67.7593467 50.167926,69.5909091 52.4272727,69.5909091 L60.6090909,69.5909091 C62.8684376,69.5909091 64.7,67.7593467 64.7,65.5 L64.7,59.9772727 C64.7049197,57.1142118 65.7106722,54.342966 67.5431818,52.1431818 C69.6732601,49.5725756 70.8381243,46.3384497 70.8363739,43 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M70.8363739,43 C70.8438966,36.6788211 66.7053949,31.1006566 60.6536033,29.2749574 C54.6018117,27.4492582 48.068888,29.8080763 44.579381,35.0788163 C41.089874,40.3495563 41.4695763,47.2848964 45.5136364,52.1431818 C47.3387769,54.3457858 48.3371915,57.1167481 48.3363636,59.9772727 L48.3363636,65.5 C48.3363636,67.7593467 50.167926,69.5909091 52.4272727,69.5909091 L60.6090909,69.5909091 C62.8684376,69.5909091 64.7,67.7593467 64.7,65.5 L64.7,59.9772727 C64.7049197,57.1142118 65.7106722,54.342966 67.5431818,52.1431818 C69.6732601,49.5725756 70.8381243,46.3384497 70.8363739,43 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M48.3363636,63.4545455 L48.3363636,65.5 C48.3363636,67.7593467 50.167926,69.5909091 52.4272727,69.5909091 L60.6090909,69.5909091 C62.8684376,69.5909091 64.7,67.7593467 64.7,65.5 L64.7,63.4545455 L48.3363636,63.4545455 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M60.6090909,70.6136364 C60.6090909,72.8729831 58.7775285,74.7045455 56.5181818,74.7045455 C54.2588351,74.7045455 52.4272727,72.8729831 52.4272727,70.6136364 L52.4272727,69.5909091 L60.6090909,69.5909091 L60.6090909,70.6136364 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="56.5386364"
            y1="24.5909091"
            x2="56.5386364"
            y2="20.5"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="69.5477273"
            y1="29.9909091"
            x2="72.4318182"
            y2="27.0863636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="74.9477273"
            y1="43"
            x2="79.0386364"
            y2="43"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="43.5090909"
            y1="29.9909091"
            x2="40.625"
            y2="27.0863636"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <line
            id="Path"
            x1="38.1295455"
            y1="43"
            x2="34.0386364"
            y2="43"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <g
            id="Group"
            transform="translate(7.181818, 0.045455)">
            <mask
              id="mask-2"
              fill="white">
              <use xlink:href="#path-1" />
            </mask>
            <g
              id="Oval"
              fill-rule="nonzero" />
            <rect
              id="Rectangle"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)"
              x="85.1522727"
              y="149.318182"
              width="38.8636364"
              height="17.3863636" />
            <line
              id="Path"
              x1="104.584091"
              y1="160.568182"
              x2="104.584091"
              y2="166.704545"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M103.05,79.7727273 C85.9090909,80.6113636 72.8590909,95.3181818 72.8590909,112.377273 L72.8590909,103.765909 L62.6318182,103.765909 C61.5021448,103.765909 60.5863636,104.68169 60.5863636,105.811364 L60.5863636,119.147727 C60.495121,125.752153 65.5038779,131.313477 72.0818182,131.911364 C78.4251471,132.400135 84.0902656,127.960387 85.1318182,121.684091 L85.1318182,158.993184 L95.3590909,158.993184 C99.0693623,158.993184 102.338943,156.555993 103.397727,153 L104.502273,149.318182 L105.831818,153.715909 C106.771851,156.85001 109.657506,158.99554 112.929545,158.993184 L123.934091,158.993184 L123.934091,151.834091 L136.206836,151.834091 L136.206836,111.477273 C136.215915,102.810926 132.677013,94.5186027 126.413338,88.5292774 C120.149663,82.5399521 111.707254,79.3757477 103.05,79.7727273 Z"
              class="fill-light"
              fill-rule="nonzero"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M103.05,79.7727273 C85.9090909,80.6113636 72.8590909,95.3181818 72.8590909,112.377273 L72.8590909,104.318182 L62.6318182,104.318182 C61.5021448,104.318182 60.5863636,105.233963 60.5863636,106.363636 L60.5863636,119.147727 C60.495121,125.752153 65.5038779,131.313477 72.0818182,131.911364 C78.4251471,132.400135 84.0902656,127.960387 85.1318182,121.684091 L85.1318182,158.993184 L95.3590909,158.993184 C99.0693623,158.993184 102.338943,156.555993 103.397727,153 L104.502273,149.318182 L105.831818,153.715909 C106.771851,156.85001 109.657506,158.99554 112.929545,158.993184 L123.934091,158.993184 L123.934091,151.834091 L136.206836,151.834091 L136.206836,111.477273 C136.215915,102.810926 132.677013,94.5186027 126.413338,88.5292774 C120.149663,82.5399521 111.707254,79.3757477 103.05,79.7727273 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M123.995455,91.0227273 C123.995455,84.8863636 117.981818,79.5068182 111.068182,78.75 L98.1818182,78.75 C91.2681818,79.5068182 85.2340909,84.8863636 85.2340909,91.0227273 L91.3704545,93.0681818 L86.2568182,99.2045455 L104.665909,126.818182 L123.075,99.2045455 L117.961364,93.0681818 L123.995455,91.0227273 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M111.722727,84.8863636 L111.722727,77.7272727 L97.4045455,77.7272727 L97.4045455,84.8863636 C96.3,89.7545455 95.175,93.5386364 96.75,98.2431818 L104.563636,126.879545 L112.5,98.1818182 C113.972727,93.5386364 112.847727,89.7545455 111.722727,84.8863636 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <polyline
              id="Path"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)"
              points="112.725 97.1386364 104.584091 92.0659091 96.4227273 97.1386364" />
            <polygon
              id="Path"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)"
              points="108.286364 94.3568182 106.629545 97.6295455 102.538636 97.6295455 100.861364 94.3568182 104.584091 92.0659091" />
            <path
              id="Path"
              d="M108.736364,111.620455 C108.613636,106.892046 107.926961,102.195187 106.690909,97.6295455 L102.6,97.6295455 C101.371865,102.196828 100.685328,106.89274 100.554545,111.620455 L104.645455,126.818182 L108.736364,111.620455 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <polygon
              id="Path"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)"
              points="111.743182 84.9068182 104.584091 92.0659091 97.425 84.9068182 97.425 73.6568182 111.743182 73.6568182" />
            <polygon
              id="Path"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)"
              points="111.743182 84.9068182 104.584091 92.0659091 97.425 84.9068182 97.425 73.6568182 111.743182 73.6568182" />
            <line
              id="Path"
              x1="85.1522727"
              y1="108.409091"
              x2="85.1522727"
              y2="121.704545"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <line
              id="Path"
              x1="124.015909"
              y1="151.834091"
              x2="124.015909"
              y2="108.409091"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M62.6318182,103.725 L62.6318182,104.318182 L72.8590909,104.318182 L72.8590909,102.272727 L74.7,101.352273 C76.0822621,100.65575 76.95305,99.2387408 76.950008,97.6909091 L76.950008,97.1590909 C76.950008,94.8997442 75.1184376,93.0681818 72.8590909,93.0681818 L72.8590909,81.8181818 C72.8590909,80.1236718 71.4854191,78.75 69.7909091,78.75 C68.0963991,78.75 66.7227273,80.1236718 66.7227273,81.8181818 L66.7227273,93.0681818 L60.5863636,93.0681818 L60.5863636,99.2045455 C61.4453921,100.624728 62.1320552,102.142254 62.6318182,103.725 L62.6318182,103.725 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <line
              id="Path"
              x1="104.584091"
              y1="149.318182"
              x2="104.584091"
              y2="126.818182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <line
              id="Path"
              x1="110.720455"
              y1="145.227273"
              x2="118.902273"
              y2="145.227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <line
              id="Path"
              x1="90.2659091"
              y1="145.227273"
              x2="98.4477273"
              y2="145.227273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <line
              id="Path"
              x1="72.8795455"
              y1="112.377273"
              x2="72.8795455"
              y2="119.659091"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M64.3909091,101.638636 L69.6681818,100.329545 C71.7000961,99.6838521 72.8256874,97.5150298 72.1840909,95.4818182 L71.6931818,93.4363636 C71.3001849,91.3429412 69.287918,89.9617944 67.1931818,90.3477273 L61.9159091,91.6568182 C60.9106886,91.9487945 60.0668361,92.635923 59.5772444,93.5611356 C59.0876527,94.4863482 58.994176,95.5705505 59.3181818,96.5659091 L59.8090909,98.6113636 C60.2399645,100.711476 62.2900835,102.066019 64.3909091,101.638636 L64.3909091,101.638636 Z"
              class="fill-white"
              fill-rule="nonzero"
              mask="url(#mask-2)" />
            <path
              id="Path"
              d="M64.3909091,101.638636 L69.6681818,100.329545 C71.7000961,99.6838521 72.8256874,97.5150298 72.1840909,95.4818182 L71.6931818,93.4363636 C71.3001849,91.3429412 69.287918,89.9617944 67.1931818,90.3477273 L61.9159091,91.6568182 C60.9106886,91.9487945 60.0668361,92.635923 59.5772444,93.5611356 C59.0876527,94.4863482 58.994176,95.5705505 59.3181818,96.5659091 L59.8090909,98.6113636 C60.2399645,100.711476 62.2900835,102.066019 64.3909091,101.638636 L64.3909091,101.638636 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              mask="url(#mask-2)" />
          </g>
          <path
            id="Path"
            d="M132.2,52.2045455 L132.2,47.0909091 C132.2,35.7941756 123.042188,26.6363636 111.745455,26.6363636 C100.448721,26.6363636 91.2909091,35.7941756 91.2909091,47.0909091 L91.2909091,52.2045455 C89.0315624,52.2045455 87.2,54.0361078 87.2,56.2954545 C87.2,58.5548012 89.0315624,60.3863636 91.2909091,60.3863636 L91.5568182,60.3863636 C93.1412281,70.3128622 101.703531,77.616884 111.755682,77.616884 C121.807832,77.616884 130.370136,70.3128622 131.954545,60.3863636 L132.2,60.3863636 C134.459347,60.3863636 136.290909,58.5548012 136.290909,56.2954545 C136.290909,54.0361078 134.459347,52.2045455 132.2,52.2045455 L132.2,52.2045455 Z"
            class="stroke fill-white"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M122.995455,54.25 C122.472181,53.0195161 121.264399,52.2206782 119.927273,52.2206782 C118.590147,52.2206782 117.382364,53.0195161 116.859091,54.25"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Path"
            d="M106.652273,54.25 C106.129,53.0195161 104.921217,52.2206782 103.584091,52.2206782 C102.246965,52.2206782 101.039182,53.0195161 100.515909,54.25"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="100.004545"
            cy="60.8977273"
            r="2.55681818" />
          <circle
            id="Oval"
            class="fill-light"
            fill-rule="nonzero"
            cx="123.527273"
            cy="60.8977273"
            r="2.55681818" />
          <path
            id="Path"
            d="M91.2909091,52.2045455 C90.5988156,52.4300618 89.840923,52.3163779 89.2454545,51.8977273 C88.6318969,51.4579178 88.2667036,50.7503559 88.2634122,49.9954545 L88.2634122,34.8181818 C88.2373396,31.7177271 90.5280033,29.0847803 93.6022727,28.6818182 C94.1189342,28.6425031 94.6014209,28.4085702 94.9522727,28.0272727 C99.8613636,22.8318182 107.593182,21.2772727 112.809091,21.4613636 C120.377273,21.7477273 127.393182,25.5522727 129.029545,33.7340909 C129.133614,34.3259255 129.492664,34.842059 130.011364,35.1454545 C133.304171,37.1660619 135.310443,40.7525646 135.309229,44.6159091 L135.309229,49.8522727 C135.31729,50.6044998 134.9589,51.3136584 134.348405,51.7532144 C133.737911,52.1927703 132.951696,52.3077274 132.240909,52.0613636 C128.777175,49.4158891 126.737036,45.3129437 126.718182,40.9545455 C126.709192,40.3082337 126.39524,39.7042006 125.87145,39.3254604 C125.347661,38.9467202 124.675673,38.8378434 124.059091,39.0318182 C120.088631,40.2836303 115.949483,40.9182997 111.786364,40.9136364 C107.313761,40.8624628 102.871311,40.1737109 98.5931818,38.8681818 C97.9638037,38.6912033 97.287745,38.8257484 96.7740812,39.2302081 C96.2604174,39.6346678 95.9710451,40.2603046 95.9954545,40.9136364 C96.7782816,45.2743166 94.9384715,49.6898608 91.2909091,52.2045455 L91.2909091,52.2045455 Z"
            class="fill-white"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M91.2909091,52.2045455 C90.5988156,52.4300618 89.840923,52.3163779 89.2454545,51.8977273 C88.6318969,51.4579178 88.2667036,50.7503559 88.2634122,49.9954545 L88.2634122,34.8181818 C88.2373396,31.7177271 90.5280033,29.0847803 93.6022727,28.6818182 C94.1189342,28.6425031 94.6014209,28.4085702 94.9522727,28.0272727 C99.8613636,22.8318182 107.593182,21.2772727 112.809091,21.4613636 C120.377273,21.7477273 127.393182,25.5522727 129.029545,33.7340909 C129.133614,34.3259255 129.492664,34.842059 130.011364,35.1454545 C133.304171,37.1660619 135.310443,40.7525646 135.309229,44.6159091 L135.309229,49.8522727 C135.31729,50.6044998 134.9589,51.3136584 134.348405,51.7532144 C133.737911,52.1927703 132.951696,52.3077274 132.240909,52.0613636 C128.777175,49.4158891 126.737036,45.3129437 126.718182,40.9545455 C126.709192,40.3082337 126.39524,39.7042006 125.87145,39.3254604 C125.347661,38.9467202 124.675673,38.8378434 124.059091,39.0318182 C120.088631,40.2836303 115.949483,40.9182997 111.786364,40.9136364 C107.313761,40.8624628 102.871311,40.1737109 98.5931818,38.8681818 C97.9638037,38.6912033 97.287745,38.8257484 96.7740812,39.2302081 C96.2604174,39.6346678 95.9710451,40.2603046 95.9954545,40.9136364 C96.7782816,45.2743166 94.9384715,49.6898608 91.2909091,52.2045455 L91.2909091,52.2045455 Z"
            class="stroke"
            stroke-width="2.04545455"
            stroke-linejoin="round" />
          <path
            id="Shape"
            d="M120.868182,72.4545455 C121.105352,70.1242916 120.93228,67.7705015 120.356818,65.5 C119.953011,63.9358209 118.535858,62.8476499 116.920455,62.8613636 L106.693182,62.8613636 C105.039958,62.7995099 103.566984,63.8978543 103.154545,65.5 C102.588603,67.7442087 102.415592,70.069476 102.643182,72.3727273 C99.2101453,70.9698469 96.0576213,68.9605459 93.3363636,66.4409091 C93.3363636,74.9090909 105.915909,80.5545455 110.293182,82.2727273 C111.234864,82.6332011 112.2765,82.6332011 113.218182,82.2727273 C117.595455,80.5545455 130.154545,74.9090909 130.154545,66.4409091 C127.449056,68.9915956 124.302456,71.0292612 120.868182,72.4545455 Z M106.672727,67.5454545 C106.752236,67.3473138 106.950691,67.2232791 107.163636,67.2386364 L116.368182,67.2386364 C116.573796,67.232236 116.761593,67.3547127 116.838636,67.5454545 C117.154189,68.404742 117.326928,69.3098957 117.35,70.225 C117.391727,72.193637 116.02508,73.91269 114.097727,74.3159091 C113.319945,74.4663341 112.53476,74.5755772 111.745455,74.6431818 C110.977826,74.5932026 110.213214,74.504453 109.454545,74.3772727 C107.527193,73.9740537 106.160546,72.2550006 106.202273,70.2863636 C106.205458,69.352912 106.364461,68.4265415 106.672727,67.5454545 Z"
            class="stroke fill-light"
            stroke-width="2.04545455"
            fill-rule="nonzero"
            stroke-linejoin="round" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
